import React from 'react'

export interface DoubleChevronUpProps {
  size?: number
  color?: string
}

export const DoubleChevronUp: React.FC<DoubleChevronUpProps> = ({
  size = 24,
  color = '#FFF',
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      >
        <path d="M0.5 8.5l4-4 4 4" transform="translate(6 6)" />
        <path d="M0.5 4.5l4-4 4 4" transform="translate(6 6)" />
      </g>
    </svg>
  )
}
